import withStyles from '@mui/styles/withStyles';

import Typography from '@classify/react-core-components/Typography';

const styles = /* istanbul ignore next */ ({ breakpoints, typography, spacing, palette }) => ({
  root: {
    color: palette.text.onMainSecondary,
    maxWidth: 968,
    minHeight: 300,
    margin: 'auto',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [breakpoints.up('sm')]: {
      paddingTop: 0,
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
  },
  picture: {
    display: 'block',
    width: '100%',
    paddingRight: 0,
    [breakpoints.up('sm')]: {
      maxWidth: '368px',
      minWidth: '368px',
      paddingRight: spacing(3),
    },
  },
  quoteContainer: {
    display: 'block',
    margin: 0,
    padding: spacing(2),
    [breakpoints.up('sm')]: {
      padding: 0,
    },
  },
  quote: {
    margin: 0,
    marginBottom: spacing(3),
    padding: 0,
    ...typography.body1,
    color: palette.text.onMainSecondary,
    [breakpoints.down('sm')]: {
      color: palette.text.onMainSecondary,
    },
  },
  student: {
    ...typography.h6,
    color: palette.text.onMainSecondary,
    fontStyle: 'normal',
    [breakpoints.down('sm')]: {
      color: palette.text.onMainSecondary,
    },
  },
  actions: {
    marginTop: spacing(1),
    marginLeft: spacing(-1),
  },
  onContrastedBackground: {
    color: palette.text.onContrasted,
    '& $quote': {
      color: palette.text.onContrasted,
      [breakpoints.down('sm')]: {
        color: palette.text.onContrasted,
      },
    },
    '& $student': {
      color: palette.text.onContrasted,
      [breakpoints.down('sm')]: {
        color: palette.text.onContrasted,
      },
    },
  },
});

const TestimonyItem = ({
  actions = null,
  children,
  classes = {},
  isOnContrastedBackground = false,
  pictureUrl,
  studentJob = '',
  studentTitle,
}) => (
  <Typography
    className={`${classes.root} ${isOnContrastedBackground ? classes.onContrastedBackground : ''}`}
    variant="h6"
    component="div"
  >
    <img className={classes.picture} src={pictureUrl} alt="" />
    <blockquote className={classes.quoteContainer}>
      <p className={classes.quote}>{children}</p>
      <footer>
        <cite className={classes.student}>
          {studentTitle}
          {studentJob && (
            <>
              <br />
              {studentJob}
            </>
          )}
        </cite>
        {actions && <div className={classes.actions}>{actions} </div>}
      </footer>
    </blockquote>
  </Typography>
);

export default withStyles(styles)(TestimonyItem);
